import { Routes } from '@angular/router';

export const monthlyCheckinRoutes: Routes = [
  {
    path: 'get-started',
    loadComponent: () => import('./monthly-follow-up/monthly-follow-up.page').then((m) => m.MonthlyFollowUpPage),
  },
  {
    path: 'question',
    loadComponent: () => import('../../shared/pages/question/question.page').then((m) => m.QuestionPage),
    data: { flowType: 'monthlyCheckin' },
  },
  {
    path: 'current-weight',
    loadComponent: () => import('../../shared/pages/weight/weight.page').then((m) => m.WeightPage),
    data: { flowType: 'monthlyCheckin' },
  },
  {
    path: 'check-address',
    loadComponent: () =>
      import('./monthly-checkin-shipping-address/monthly-checkin-shipping-address.page').then(
        (m) => m.MonthlyCheckinShippingAddressPage,
      ),
  },
  {
    path: 'summary',
    loadComponent: () => import('./monthly-summary/monthly-summary.page').then((m) => m.MonthlySummaryPage),
  },
  {
    path: 'health-coach-schedule',
    loadComponent: () =>
      import('./health-coach-schedule/health-coach-schedule.page').then((m) => m.HealthCoachSchedulePage),
  },
  {
    path: 'confirm-health-coach-appointment',
    loadComponent: () =>
      import('./confirm-health-coach-appointment/confirm-health-coach-appointment.page').then(
        (m) => m.ConfirmHealthCoachAppointmentPage,
      ),
  },
  {
    path: 'confirm-appointment',
    loadComponent: () =>
      import('../../shared/pages/flow-schedule-confirmation/flow-schedule-confirmation.page').then(
        (m) => m.FlowScheduleConfirmationPage,
      ),
    data: { flowType: 'monthlyCheckin' },
  },
];
